var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h1',{staticClass:"text-9xl mt-20",domProps:{"textContent":_vm._s('Add IFCHearts')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }